<template>
	<main>
		<!-- 导航 -->
		<navbar active="3" @changeTab="changeTab"></navbar>

		<section class="content" :class="{en: globalLang === 'en' || globalLang === 'th' || globalLang === 'vi'}">
			<div class="top-line">
				<el-row type="flex" justify="space-between">
					<el-col :span="6">
						<div class="grid-content">
							<el-select v-model="statusValue" @change="changeStatus" :placeholder="$t('service.allRecord')">
								<el-option
								v-for="item in statusOptions"
								:key="item.value"
								:label="item.label"
								:value="item.value">
								</el-option>
							</el-select>
						</div>
					</el-col>
					<el-col :span="6">
						<div class="grid-content">
							<div class="top-btn" @click="goAsk" ga-data="2001001">{{$t('service.myInquires')}}</div>
						</div>
					</el-col>
				</el-row>
			</div>

			<div class="table-wrap" v-loading="loading">
				<div class="table-title">
					<el-row :gutter="20">
						<el-col :span="6"><div class="grid-content">{{$t('service.questionsTime')}}</div></el-col>
						<el-col :span="6"><div class="grid-content">{{$t('service.gameName')}}</div></el-col>
						<el-col :span="6"><div class="grid-content">{{$t('service.questionsTitle')}}</div></el-col>
						<el-col :span="6"><div class="grid-content">{{$t('service.caseType')}}</div></el-col>
					</el-row>
				</div>
				<div class="table-con">
					<el-row :gutter="20" v-for="item in questionList" :key="item.work_order_id" @click.native="showDetail(item)">
						<el-col :span="6"><div class="grid-content">{{item.create_time}}</div></el-col>
						<el-col :span="6"><div class="grid-content">{{item.game_name}}</div></el-col>
						<el-col :span="6"><div class="grid-content">{{item.question_title}}</div></el-col>
						<el-col :span="6">
							<div class="grid-content">
								<span class="status-tag" :class="{black: item.work_order_status === 1, pink: item.work_order_status === 2, green: item.work_order_status === 3,
								grey: item.work_order_status === 4}">{{statuses[item.work_order_status - 1]}}</span>
							</div>
						</el-col>
					</el-row>
					<div class="empty-data" v-if="questionList.length == 0 && !loading">{{ $t('service.emptyData') }}</div>
				</div>
				<el-pagination
					v-if="questionList.length > 0"
					layout="prev, pager, next"
					@current-change="getWorkOrders"
					:current-page.sync="pageOptions.pageIndex"
					:page-size="pageOptions.pageSize"
					:total="pageOptions.totalNum">
				</el-pagination>
			</div>
		</section>

	</main>
</template>

<script>
    import Vue from 'vue';

	import { Row, Col, Select, Option, Pagination, Loading } from 'element-ui';

	Vue.component(Row.name, Row);
	Vue.component(Col.name, Col);
	Vue.component(Select.name, Select);
	Vue.component(Option.name, Option);
	Vue.component(Pagination.name, Pagination);
	Vue.use(Loading.directive);

	import navbar from './component/navbar';
	
	export default {
		name: "index",
		data() {
			return {
				statuses: [
					this.$t('service.noReply'),
					this.$t('service.processing'),
					this.$t('service.replied'),
					this.$t('service.closedCases')
				],
				statusOptions: [
					{
						value: 1,
						label: this.$t('service.noReply')
					},
					{
						value: 2,
						label: this.$t('service.processing')
					},
					{
						value: 3,
						label: this.$t('service.replied')
					},
					{
						value: 4,
						label: this.$t('service.closedCases')
					}
				],
				statusValue: '',
				pageOptions: {
					pageSize: 7,
					pageIndex: 1,
					totalNum: 0
				},
				questionList: [
				],
				loading: false
			};
		},
		components: {
			navbar
		},
		methods: {
			changeStatus (){
				this.pageOptions.pageIndex = 1;
				this.getWorkOrders();
			},
			goAsk (){
				this.$router.push('/service/question');
			},
			showDetail (item){
				this.$router.push({name:'servicePCOrderDetail',query: {id: item.work_order_id}});
			},
			getWorkOrders (){
				var _this = this;
				this.loading = true;
				this.questionList = [];
				this.$apis.service.getWorkOrder(_this.statusValue, _this.pageOptions.pageIndex, _this.pageOptions.pageSize, this.$utils.token("joy_jct")).then(res => {
					var resData = res.data;
					if(resData.code === 0){
						if(resData.data.count > 0){
							_this.pageOptions.totalNum = resData.data.count ? resData.data.count : 0;
							_this.pageOptions.pageIndex = resData.data.page_num || 1;
							_this.questionList = resData.data.result;
						}
					}
					this.loading = false;
				});
			},
			// 切换导航栏
			changeTab(url) {
				this.$router.push({
						path: url
				});
			},
		},
		created: function() {
			this.getWorkOrders();
		},
		mounted: function() {
			window.scrollTo(0, 0);
		}
	};
</script>

<style lang="scss" scoped>
	/deep/ .content {
		margin: 0 auto;
		width: 1170px;

		&.en {
			.el-select .el-input__inner, .el-select .el-input__inner:focus, .el-select .el-input.is-focus .el-input__inner {
				border-width: 1px;
			}
		}

		.top-line {
			padding: 40px 0;
		}
		.top-btn {
			float: right;
			width: 160px;
			height: 40px;
			line-height: 40px;
			background: #50BBE5;
			border-radius: 100px;
			font-size: 16px;
			color: #FFFFFF;
			text-align: center;
			cursor: pointer;
			transition: all 0.3s;
			&:hover {
				box-shadow: 0 4px 6px 0 rgba(10,131,186,0.3);
			}
		}
		.grid-content {
			position: relative;
		}
		.status-tag {
			display: inline-block;
			width: 60px;
			height: 20px;
			line-height: 20px;
			border-radius: 20px;
			font-size: 12px;
			vertical-align: middle;
			color: #fff;
			text-align: center;
			&.black {
				background: #999999;
			}
			&.pink {
				background: #FFA0A0;
			}
			&.green {
				background: #8FD7C1;
			}
			&.grey {
				background: #CCCCCC;
			}
		}
		.el-select .el-input .el-select__caret {
			margin-right: 10px;
			width: 12px;
			background: url('../images/arrow_up_circle.svg') no-repeat;
			background-size: 100% auto;
			background-position: center;
			&:before {
				content: '';
			}
		}
		.sel-arr {
			display: none;
			position: absolute;
			right: 78px;
			top: 50%;
			transform: translateY(-50%);
			width: 12px;
			transition: transform 0.3s;
			&.reverse {
				transform: translateY(-50%) rotate(-180deg);
			}
		}
		.popper__arrow {
			display: none !important;
		}
		.el-popper {
			margin-top: 8px !important;
		}
		.el-select-dropdown__item.selected {
			color: #50BBE5;
		}
		.el-scrollbar__bar.is-vertical {
			// width: 10px;
		}
		.el-scrollbar__thumb {
			right: 6px;
			background-color: rgba(139, 195, 74, .6);
		}
		.el-select-dropdown__list {
			height: 150px;
		}
		.el-select-dropdown {
			border-radius: 12px;
		}
		.el-select .el-input__inner, .el-select .el-input__inner:focus, .el-select .el-input.is-focus .el-input__inner {
			width: 240px;
			border-width: 2px;
			border-radius: 40px;
			&:hover {
				border-color: #50BBE5;
			}
		}
		.el-select .el-input__inner:focus, .el-select .el-input.is-focus .el-input__inner {
			border: 2px solid #50BBE5;
		}
		.el-loading-spinner .path {
			stroke: #50BBE5;
		}
		.table-wrap {
			margin-bottom: 137px;
			text-align: center;
		}
		.table-title {
			height: 60px;
			line-height: 60px;
			font-size: 12px;
			color: #999999;
			border-bottom: 1px solid #EEEEEE;
			.el-row {
				margin-left: 0 !important;
				margin-right: 0 !important;
			}
		}
		.table-con {
			line-height: 100px;
			min-height: 304px;
			font-size: 14px;
			color: #444444;
			text-align: center;
			border-bottom: 1px solid #EEEEEE;
			.grid-content {
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}
			.el-row {
				margin-left: 0 !important;
				margin-right: 0 !important;
				border-bottom: 1px dotted #BDBDBD;
				cursor: pointer;
				&:last-child {
					border: none;
				}
				&:hover {
					color: #50BBE5;
				}
			}
		}

		.el-pagination {
			padding-top: 31px;
			font-weight: normal;
		}
		.el-pager li {
			margin: 0 4px;
			width: 32px;
			min-width: 32px;
			height: 32px;
			border: 1px solid #CCCCCC;
			border-radius: 4px;
			&:hover {
				color: #50BBE5;
			}
			&.active {
				color: #fff;
				border-color: #50BBE5;
				background-color: #50BBE5;
			}
		}
		.el-pagination button {
			width: 32px;
			min-width: 32px;
			height: 32px;
			border: 1px solid #CCCCCC;
			border-radius: 4px;
			box-sizing: border-box;
			&:hover {
				color: #50BBE5;
			}
			.btn-next {
				padding-left: 7px;
			}
			.btn-prev {
				padding-right: 7px;
			}
		}
		.el-pager li.active+li {
			border: 1px solid #CCCCCC;
		}
	}
</style>
